/**
 * Shared validation helpers
 */

/**
 * Validate non-negative stock and thresholds
 * @param {number} value
 * @returns {true|string}
 */
export function validateNonNegative(value) {
  if (value == null || value === '') return 'Value is required';
  if (Number.isNaN(Number(value))) return 'Value must be a number';
  if (Number(value) < 0) return 'Value cannot be negative';
  return true;
}

/**
 * Ensure max >= min
 * @param {number} min
 * @param {number} max
 * @returns {true|string}
 */
export function validateMinMax(min, max) {
  if (min == null || max == null) return 'Both min and max are required';
  if (Number(min) > Number(max)) return 'Max capacity must be greater than or equal to min threshold';
  return true;
}

/**
 * Sanity check for lead time and costs
 * @param {{leadTimeDays?: number, costPerUnit?: number}} item
 * @returns {true|string}
 */
export function validateLeadTimeAndCost(item) {
  if (item.leadTimeDays != null && item.leadTimeDays < 0) return 'Lead time cannot be negative';
  if (item.costPerUnit != null && item.costPerUnit < 0) return 'Cost cannot be negative';
  return true;
}